<template>
    <div v-if="false"></div>
</template>

<script>
    /**
     * NOTE: this component only handles a dynamic updater for dam info
     * Reason to use:
     * 1. Main container for Right panel should not be destroyed as to have animation.
     * 2. If no dam selected, do not fetch data.
     * 3. If dam selected, then second, clear interval and get data immediately, set interval
     */

    // vuex
    import {mapGetters, mapActions} from "vuex";
    import {GET_DAM_DATA, SET_DAM_ERROR} from "../../store/actions/dashboard";
    import {UPDATE_RIGHT_PANEL_INTERVAL} from "../../constants/general-constants";

    export default {
        name: "DamDataUpdater",
        data() {
            return {
                updateDamInterval: null
            }
        },
        async mounted() {
            await this.dispatchDamUpdate();
            await this.updateDamData();
        },
        computed: {
            ...mapGetters(['currentDamSelectedId']),
        },
        watch: {
            /**
             * In rare cases the previous interval is not cleared properly.
             */
            currentDamSelectedId() {
                clearInterval(this.updateDamInterval);
                this.updateDamData();
            }
        },
        methods: {
            ...mapActions([GET_DAM_DATA, SET_DAM_ERROR]),
            async dispatchDamUpdate() {
                try {
                    await this.GET_DAM_DATA(this.currentDamSelectedId);
                    this.SET_DAM_ERROR(false);
                }
                catch (e) {
                    clearInterval(this.updateDamInterval);
                    this.SET_DAM_ERROR(true);
                }
            },
            async updateDamData() {
                this.updateDamInterval = setInterval( this.dispatchDamUpdate , UPDATE_RIGHT_PANEL_INTERVAL);
            },
            setError() {

            }
        },
        beforeDestroy() {
            clearInterval(this.updateDamInterval);
        }
    }
</script>
